const ijhsPendingCountReducer = (state = 0, action) => {
  switch (action.type) {
    case "SET_IJHS_PENDING_COUNT":
      return Number(action.count) || 0;
    default:
      return state;
  }
};

export default ijhsPendingCountReducer;
